import { useCallback } from 'react';
import { useMutation } from '@tanstack/react-query';
import { configureAffinity } from '../../../services/queries/MaggieIntegrationsQueries';
import { AffinityFormValues } from './affinityConfig.schema';

export function useAffinityConfigActions() {
  const mutation = useMutation({
    mutationFn: configureAffinity,
  });

  const saveConfig = useCallback(
    async (values: AffinityFormValues) => {
      const result = await mutation.mutateAsync({
        apiKey: values.apiKey.trim(),
      });
      return result;
    },
    [mutation]
  );

  return { saveConfig, isSubmitting: mutation.isPending };
}
